export default __webpack_public_path__ + "static/media/SignupCarouselSS2.84b2a09b.svg";